export const BACKEND_ENDPOINT =
  process.env.NEXT_PUBLIC_BACKEND_ENDPOINT ||
  'https://testlink.scopetickets.com';
export const FRONTEND_BASE_URL =
  process.env.NEXT_PUBLIC_WEB_URL || 'http://localhost:3000';
export const CART_ID_COOKIE = 'st_cid';
/** Written when a payment is submitted, so the confirmation step knows its age. */
export const PAYMENT_SUBMITTED_AT_KEY = 'st_payment_submitted_at';
/**
 * Give the processor this long to settle before the first confirmation
 * attempt. Asking earlier mostly buys a 409 and a wasted round trip.
 */
export const PAYMENT_SETTLE_FLOOR_MS = 3000;
export const DATE_FORMAT_SHORT = 'D MMMM';
export const DATE_FORMAT_MEDIUM = 'D MMMM YYYY';
export const DATE_FORMAT_LONG = 'dddd, D MMMM YYYY';
export const DEBUG = process.env.NEXT_PUBLIC_DEBUG || false;
export const ESCROW_EXPIRY_MINUTES = 9.95; // 3 sec less than 10 mins to have a safety margin to the API calculation
export const SESSION_ID_COOKIE = 'st_sid';
export const SESSION_COOKIE_EXPIRATION = 2 / 24; // 2h expressed as days
export const STRIPE_KEY =
  process.env.NEXT_PUBLIC_STRIPE_KEY || 'pk_test_05DPgZ5HyftRNAZbt7RPH6tM';
export const DATEPICKERTYPE = {
  Calendar: 'calendar',
  List: 'list',
} as const;
export const ALLOWED_PATHS_AFTER_PAYMENT = [
  '/event/[eventId]/checkout/contact',
  '/event/[eventId]/checkout/guests/[guestIndex]',
  '/event/[eventId]/checkout/confirm',
  '/event/[eventId]/checkout/tickets',
];
